<script>
import options from "./ContactCardPermission.options"
export default options
</script>

<template>
  <article class="nyk-contact-card" :class="contactCardClassNames">
    <component
      :is="currentStepName"
      :nextStepCallback="validateInputAndProceed"
      :previousStepCallback="returnToPreviousStep"
      :displayInputError="displayInputError"
      :currentStepTexts="currentStepTexts"
      :hasPreviousStep="hasPreviousStep"
      :resetSignupForm="resetSignupForm"
      :getNamedFieldInputData="getNamedFieldInputData"
      :showFieldErrorMessage="showFieldErrorMessage"
      :stepCounterText="stepCounterText"
      :imageSource="imageSource"
      :imageAltText="imageAltText"
      :labels="labels"
      :newslettersData="newsletters"
      :alwaysShowCprField="alwaysShowCprField"
      :alwaysShowPostalCodeField="alwaysShowPostalCodeField"/>
  </article>
</template>
